const config = { clarityId: '89f0t3fsax' };

export default config;
